var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Grid',_vm._b({ref:"gridEl",attrs:{"column-defs":_vm.columnDefs,"row-data":_vm.rowData,"overlay-no-rows-template":_vm.noRowsTemplate}},'Grid',_vm.dynamicProps(),false))}
var staticRenderFns = []

export { render, staticRenderFns }